import { useMemo } from 'react';

import { makeStyles } from 'tss-react/mui';
import { FlexTableColumn } from '@uplift/ui-v2';

import {
  NameCell, PsychiatristCell, ReferralCell, SessionsCell, StatusCell, TherapistCell
} from './cells';
import { StudentTableRow } from './types';

export const useStudentsTableColumns = (isCareApp: boolean): FlexTableColumn<StudentTableRow>[] => {
  const { classes } = useColumnsStyles();

  return useMemo(() => [
    {
      field: 'referral',
      headerName: 'Referral',
      renderCell: params => <ReferralCell {...params} isCareApp={isCareApp}/>,
      width: isCareApp ? 150 : 90,
      sortable: true,
      cellClassName: classes.referralPadding,
    } as FlexTableColumn<StudentTableRow, 'referral'>,
    {
      field: 'student',
      headerName: 'Name',
      renderCell: params => <NameCell {...params} isCareApp={isCareApp}/>,
      width: 200,
      sortable: true,
      sortComparator: (a, b) => (a.fullName || '').localeCompare(b.fullName || ''),
    } as FlexTableColumn<StudentTableRow, 'student'>,
    {
      field: 'therapist',
      headerName: 'Therapist',
      renderCell: params => <TherapistCell {...params} isCareApp={isCareApp} />,
      width: 150,
      sortable: true,
      sortComparator: (a, b) => (a.fullName || '').localeCompare(b.fullName || ''),
    } as FlexTableColumn<StudentTableRow, 'therapist'>,
    {
      field: 'psychiatrist',
      headerName: 'Psychiatry Provider',
      renderCell: params => <PsychiatristCell {...params} isCareApp={isCareApp} />,
      width: 150,
      sortable: true,
      sortComparator: (a, b) => (a.fullName || '').localeCompare(b.fullName || ''),
    } as FlexTableColumn<StudentTableRow, 'psychiatrist'>,
    {
      field: 'status',
      headerName: 'Status',
      renderCell: params => <StatusCell {...params} isCareApp={isCareApp} />,
      width: 110,
      sortable: true,
    } as FlexTableColumn<StudentTableRow, 'status'>,
    {
      field: 'sessions',
      headerName: 'Sessions',
      renderCell: params => <SessionsCell {...params}/>,
      width: 50,
      sortable: true,
      align: 'right',
    } as FlexTableColumn<StudentTableRow, 'sessions'>,
    // TODO: FIX TYPE OF FlexTableColumn
  ], [ classes.referralPadding, isCareApp ]) as FlexTableColumn<StudentTableRow>[];
};

const useColumnsStyles = makeStyles({ name: 'Columns' })(() => ({
  referralPadding: {
    paddingLeft: '0',
  }
}));
